import Button from 'components/ui-components/Button';
import { white, information, grey50 } from 'constants/variables';
import { PlusIcon, InfoIcon } from 'assets/icons';
import ApprovalsGroupUser from './approvals_group_user';

const ApprovalsGroupSelectedUsers = ({
  displayText,
  userCount,
  users,
  isValid,
  errorMsg,
  errorRef,
  classes,
  openUsersModal,
  openUserMessageModal,
  isAdmin,
}) => {
  const { title, description, cta } = displayText;

  const noUsersToRender = userCount === 0;

  const filterSelectedUsers = usersList =>
    usersList.filter(user => user.selected);

  const selectedUsers = filterSelectedUsers(users);

  return (
    <div className={classes}>
      <h3 className="ff-body fw-600 fs-15 tc-grey-70 lh-1 mb-10">{title}</h3>
      <p className="ff-body fs-14 tc-oa-grey lh-1 mb-10">{description}</p>
      {noUsersToRender && (
        <p className="fl ai-c ff-body fw-600 fs-14 tc-grey-70 lh-1 mb-10 mt-8">
          <InfoIcon width="18" height="18" fillColor={information} />
          <span className="ml-6">
            {`No ${title.slice(0, -1)} roles have been created yet`}
          </span>
        </p>
      )}
      {selectedUsers.length > 0 && (
        <>
          <div className="fl mb-5 pt-5">
            <p className="create-group-users__title ff-body fs-14 tc-grey-70 lh-1 mb-0 ml-12">
              Name
            </p>
            <p className="ff-body fs-14 tc-grey-70 lh-1 mb-0">
              {`${
                title.toLowerCase().includes('user') ? 'Credit' : 'Approval'
              } Limit`}
            </p>
          </div>
          <ul className="create-group-users__wrapper ml-0 mb-12">
            {selectedUsers.map(user => (
              <ApprovalsGroupUser
                isAdmin={isAdmin}
                usersLength={users.length}
                userCount={userCount}
                key={user.customer_id}
                title={title}
                user={user}
                openUserMessageModal={openUserMessageModal}
              />
            ))}
          </ul>
        </>
      )}
      <Button
        className={`${
          noUsersToRender ? 'bg-grey-5 tc-grey-50' : 'bg-cef-red tc-white'
        } ptb-12 plr-14`}
        handleClick={() => openUsersModal(title)}
        disabled={noUsersToRender}>
        <PlusIcon
          width="12"
          height="12"
          fillColor={noUsersToRender ? grey50 : white}
        />
        <span className="ml-8"> {cta}</span>
      </Button>
      {!isValid && (
        <p className="ff-body fs-12 tc-cef-red lh-1 mt-8 mb-18" ref={errorRef}>
          {errorMsg}
        </p>
      )}
    </div>
  );
};

export default ApprovalsGroupSelectedUsers;
